import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import type { TimeseriesPoint } from '@entities/stats';
import { formatDate } from '@shared/lib/format';

export function Sparkline({ points }: { points: TimeseriesPoint[] }) {
  if (!points.length) {
    return <div className="h-12 text-xs text-muted-foreground">нет данных</div>;
  }
  return (
    <div className="h-12 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={points} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id="sparkFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity={0.35} />
              <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="bucket" hide />
          <Tooltip
            cursor={{ stroke: 'hsl(var(--border))' }}
            contentStyle={{
              background: 'hsl(var(--card))',
              border: '1px solid hsl(var(--border))',
              borderRadius: 6,
              fontSize: 12,
              padding: '4px 8px',
            }}
            labelFormatter={(value) => formatDate(String(value))}
            formatter={(value: number) => [value, 'count']}
          />
          <Area
            type="monotone"
            dataKey="count"
            stroke="hsl(var(--primary))"
            strokeWidth={1.5}
            fill="url(#sparkFill)"
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
